<template>
    <transition name="slide">
        <keep-alive>
            <div :class="['aside-menu', { 'collapsed': isOpenAside && !isGuest, 'dark-mode': isDarkMode }]">
                <div class="mode-settings pb-3">
                    <span class='mode'> Mode </span>
                    <label class="switch-mode">
                        <input type="checkbox" v-model="is_dark" @change="toggleDarkMode" name="mode">
                        <span class="slider"></span>
                    </label>
                </div>
                <nav class="nav flex-column">
                    <ul>
                        <router-link to="/dashboard" exact-active-class="active" v-slot="{ isActive }" v-on:click="toggleCloseOrderMenu">
                            <li :class="{ active: isActive && routerLinkActive }">
                                <font-awesome-icon icon="chart-line" class="me-3" />
                                Dashboard
                            </li>
                        </router-link>
                        <router-link to="/accounts" v-if="isSuperOrAdminAccount" exact-active-class="active" 
                            v-slot="{ isActive }" v-on:click="toggleCloseOrderMenu">
                            <li :class="{ active: isActive && routerLinkActive}">
								<font-awesome-icon :icon="['fas','user-group']" class="me-3"/>
                                User Accounts
                            </li>
                        </router-link>
                        <ul>
                            <a href="#" class="has-sub-menu" v-on:click="toggleOpenOrderMenu">
                                <li :class="{ active: mainMenuIsActive, open: isOrderMenuOpen }">
									<font-awesome-icon :icon="['fas','list']" class="me-3"/>
                                    Orders
									<font-awesome-icon
										:icon="['fas', 
										mainMenuIsActive && isOrderMenuOpen ? 'chevron-down' : 'chevron-right']"
										class="chevron"
									/>
                                </li>
                            </a>
                            <li class="sub-menu" v-if="isOrderMenuOpen">
                                <router-link 
                                    :to="'/order/step-one/new'" 
                                    v-if="canMakeOrder" 
                                    exact-active-class="active" 
                                    >
                                    <li :class="{ active: subRouterLinkActive }">
										<font-awesome-icon :icon="['fas','plus-square']" class="mx-3"/>
                                        New Order
                                    </li>
                                </router-link>
                                <router-link to="/orders" exact-active-class="active" v-slot="{ isActive }">
                                    <li :class="{ active: isActive }">
										<font-awesome-icon :icon="['fas','list-ol']" class="mx-3"/>
                                        Order List
                                    </li>
                                </router-link>
                            </li>
                        </ul>
                        <!-- <router-link to="/price/approvals" exact-active-class="active" v-slot="{ isActive }" v-on:click="toggleCloseOrderMenu">
                            <li :class="{ active: isActive && routerLinkActive }">
                                <font-awesome-icon icon='fa-comments-dollar' class="me-3" />
                                Price Approvals
                            </li>
                        </router-link> -->
                        <router-link to="/chat/rooms" exact-active-class="active" v-slot="{ isActive }" v-on:click="toggleCloseOrderMenu">
                            <li :class="{ active: isActive && routerLinkActive }">
                                <font-awesome-icon :icon="['fas','message']" class="me-3" />
                                Chat Rooms
                            </li>
                        </router-link>
                        <!-- <router-link to="/settings" v-if="isSuperOrAdminAccount" exact-active-class="active" 
                            v-slot="{ isActive }" v-on:click="toggleCloseOrderMenu">
                            <li :class="{ active: isActive && routerLinkActive}">
								<font-awesome-icon :icon="['fas','gears']" class="me-3"/>
                                Settings
                            </li>
                        </router-link> -->
                    </ul>
                </nav>
            </div>
        </keep-alive>
    </transition>
</template>

<script src="./AsideScript.vue"/>